import React from "react";
import { MdArrowBackIosNew } from "react-icons/md";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import useTours from "./hooks/useTours";
import SingleConcert from "./singleConcert";
import EASkeletonLoader from "../shared/EASkeletonLoader";

const TourDetails: React.FC = () => {
  const { t } = useTranslation();
  const { exercises, navigateToTourSale, loading, exerciseName, exerciseDescription } = useTours();

  if (loading) {
    return <EASkeletonLoader height="400px" />;
  }

  if (exercises.length <= 0) {
    return <div className="alert alert-yellow">Nie znaleziono wydarzeń.</div>;
  }

  return (
    <>
      <div className="modal-window-header flex-start">
        <EAButton title={t("wroc")} onClick={navigateToTourSale} startIcon={<MdArrowBackIosNew />} variant="text" />
        <div>
          <h1>
            {t("kup_bilet")}:<b>{exerciseName}</b>
          </h1>
          <article dangerouslySetInnerHTML={{ __html: exerciseDescription }}></article>
        </div>
      </div>

      <div>
        {exercises && (
          <div>
            {exercises.map((item, index) => (
              <div className={"event-block"} key={index}>
                <SingleConcert item={item} />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default TourDetails;
